import React from 'react';
import { Panel, PanelGroup, Checkbox } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { EMPTY_COUNT } from '../../../utils/constants';
import { contactSelectors } from './state';

const DistributorChecklist = (props) => {
    const renderPartner = (partner, index) => {
        let stringPartner = JSON.stringify(partner);
        let parsedPartner = JSON.parse(stringPartner);

        return (
            <h5 key={index}>
                <Checkbox
                    name="checkedPartners"
                    onChange={props.handleCheckboxChange.bind(this, parsedPartner.proposalId)}
                    value={stringPartner}
                    className="labeled-checklist"
                    disabled={props.view}
                    checked={props.view || contactSelectors.isPartnerChecked(props.checkedPartners, parsedPartner)}
                >
                    {partner.customerName}
                </Checkbox>
            </h5>
        )
    }

    const renderProposal = (proposal) => {
        let proposalId = proposal.proposalId;
        let checkedCount = props.checkedPartners.filter(item => item.proposalId === proposalId).length;
        let partnerCount = proposal.partners.length;
        let isChecked = checkedCount === partnerCount && EMPTY_COUNT < checkedCount;

        return (
            <Panel
                eventKey={proposalId}
                key={proposalId}
                id={proposalId}
                className="no-border"
                expanded={props.toggles[String(proposalId)] && EMPTY_COUNT < partnerCount}
                onToggle={()=>{}}
            >
                <div className="flex">
                    <Checkbox
                        id={`indeterminate_${proposalId}`}
                        value={proposalId}
                        onChange={props.handleGroupCheckboxChange}
                        onClick={props.handleGroupCheckboxChange}
                        checked={isChecked || props.view}
                        disabled={EMPTY_COUNT >= partnerCount || props.view}
                        className="distributor-checklist"
                    />

                    <div className="full-width">
                        <Panel.Heading className="flex pointer" onClick={props.toggleList.bind(this, proposalId)}>
                            <Panel.Toggle
                                disabled={EMPTY_COUNT >= partnerCount}
                                className="panel-toggle"
                            >
                                <FontAwesomeIcon icon={props.toggles[String(proposalId)] ? ['far', "minus-square"] : ['far', "plus-square"]} color="#000" className="panel-icon" />
                            </Panel.Toggle >
                            <Panel.Title className="full-width">{proposal.proposalName}</Panel.Title>
                        </Panel.Heading>

                        <Panel.Collapse>
                            <Panel.Body className="custom-panel-body">
                                {proposal.partners.map((partner, index) => {
                                    return (renderPartner(partner, index));
                                })}
                            </Panel.Body>
                        </Panel.Collapse>
                    </div>
                </div>
            </Panel>
        );
    }

    return (
        <PanelGroup id="distributor-list">
            {props.list.map((data) => renderProposal(data))}
        </PanelGroup>
    );

}

export default DistributorChecklist;